import { Grid } from '@material-ui/core';
import React from 'react';

import { saveAdminDepartment, updateAdminDepartment } from 'api/hs/definitions/workplace-definition/department';
import BaseDefinitionForm from 'Common/BaseDefinitionForm';
import TextField from 'Common/Form/TextField';
import { Department } from 'model/definitions/workplace-definition/department.model';

interface Props {
  open: boolean;

  /**
   * Fires when the dialog is wanted to be closed
   * @param success `true` when the department is created/updated
   */
  onClose(success: boolean): void;

  data: Department;
}

export default function AdminDepartment({ open, onClose, data }: Props) {
  return (
    <BaseDefinitionForm<Department>
      open={open}
      onClose={onClose}
      onSave={saveAdminDepartment}
      onUpdate={updateAdminDepartment}
      data={data}
      resourceReloadName="departments"
      createTitle="Departman Ekle"
      updateTitle="Departman Düzenleme"
      maxDialogWidth={500}>
      <Grid item lg={12} md={12}>
        <TextField required name="departmentName" label="Departman Adı" />
      </Grid>
    </BaseDefinitionForm>
  );
}
